export function isPublicSellerPage(pathname: string): boolean { return /^\/seller-report\/[^/]+(?:\/|$)/.test(pathname); }
export function isPublicSellerRequest(value: string, base = 'http://localhost'): boolean {
  try { const pathname = new URL(value, base).pathname; return /^\/(?:api\/)?seller-report\/[^/]+(?:\/|$)/.test(pathname); } catch { return false; }
}
export function publicReportOptions(options?: RequestInit, request?: Request): RequestInit {
  const headers = new Headers(request?.headers); new Headers(options?.headers).forEach((value, name) => headers.set(name, value));
  headers.delete('Authorization'); headers.delete('X-Active-Context'); headers.delete('Cookie');
  return { ...options, headers, credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store' };
}